import React, { FC } from 'react';

import DangerouslySetInnerHtml from 'layout/DangerouslySetInnerHtml';

import { SoBannerItemProps } from '../../models';

const TextVariant: FC<SoBannerItemProps> = ({
  data: {
    imageDesktop,
    imageMobile,
    extraClass,
    legalText,
    bannerText,
    button,
    buttonType,
    videoBanner,
    videoBannerMobile,
  },
  index,
}) => (
  <div
    className={`banner__item banner__item--text-variant banner__item--${extraClass || ''}`}
    key={`sobannerItemText_${index}`}
  >
    {videoBannerMobile?.url ? (
      <video className="d-md-none banner__item-video--mobile" autoPlay muted loop playsInline>
        <source src={videoBannerMobile?.url} type="video/mp4" />
      </video>
    ) : (
      <></>
    )}
    {videoBanner?.url ? (
      <video
        className="d-none d-md-block banner__item-video--dektop"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={videoBanner?.url} type="video/mp4" />
      </video>
    ) : (
      <></>
    )}
    {imageDesktop ? (
      <div className="d-none d-md-block videoPoster">
        <img
          src={imageDesktop.fallbackUrl}
          alt={imageDesktop.altText ? imageDesktop.altText : ''}
        />
      </div>
    ) : (
      <></>
    )}
    {imageMobile ? (
      <div className="d-block d-md-none videoPoster">
        <img src={imageMobile.fallbackUrl} alt={imageMobile.altText ? imageMobile.altText : ''} />
      </div>
    ) : (
      <></>
    )}
    <div className="banner__info">
      <div className="banner__info-content">
        {bannerText ? <DangerouslySetInnerHtml html={bannerText as string} /> : <></>}
        {button.url ? (
          <a href={button.url} className={`btn ${buttonType ? `btn--${buttonType}` : ''}`}>
            {button.name}
          </a>
        ) : (
          <></>
        )}
      </div>
      {legalText ? (
        <div className="legal-text">
          <DangerouslySetInnerHtml html={legalText as string} />
        </div>
      ) : (
        <></>
      )}
    </div>
  </div>
);

export default TextVariant;
